module.exports = __webpack_public_path__ + "static/media/retweetWhiteOutlined.c5d8ce4c.svg";